module.exports = __webpack_public_path__ + "img/kr-product-final-card1-icon1.b12da55.png";